<template>
    <div class="zq-popup zq-popup--full-screen zq-popup--visible">
        <div class="zq-popup__container">
            <div class="zq-popup__title">
                {{activity.name}}
                <div @click="closePopup()" class="zq-popup__close-button closePopup"
                     data-close-popup-id="activity-detail-popup"></div>
                <div class="your-dates__month-switcher">
                    <button v-if="canGoBack" @click="monthBack()"
                            class="your-dates__month-switcher-arrow your-dates__month-switcher-arrow--left"></button>
                    <strong>{{selected_month|moment('MMMM YYYY')}}</strong>
                    <button @click="monthForward()"
                            class="your-dates__month-switcher-arrow your-dates__month-switcher-arrow--right"></button>
                </div>
            </div>
            <div class="zq-popup__content custom-scroller">
                <form class="form">
                    <div class="your-dates__energy-supported-days">
                        <div v-if="datesForSelectedSubcategory.length == 0 && datesFromDifferentSubcategories.length == 0" class="empty-list" :key="'no-supported-days'" v-translate="{month: selectedMonth, category: categoryName}">
                            In %{month} there are no energy supported days for %{category} and its compatible subcategories.
                        </div>
                        <div v-if="datesForSelectedSubcategory.length == 0 && datesFromDifferentSubcategories.length>0" class="empty-list" :key="'only-compatible'" v-translate="{month: selectedMonth, subcategory: subcategoryName}">
                            In %{month} there are no energy supported days for %{subcategory} but you can choose dates from compatible subcategories instead.
                        </div>
                        <div v-if="datesForSelectedSubcategory.length>0" :key="'personal-energy-supported-days'" class="your-dates__container">
                            <div class="your-dates__title"><translate>Your personal energy supported days in</translate>
                                {{selected_month|moment('MMMM YYYY')}}
                            </div>
                            <!--<div class="your-dates__description">Explain ... if its possible choose among these days
                                because bla bla bla ...
                            </div>-->
                            <energy-supported-date :activity="activity" v-for="(day,index) in datesForSelectedSubcategory" :day="day"
                                                   v-model="selected_date" :key="day.date+index"/>

                            <!--
                            <div class="your-dates__date your-dates__date--upgrade-subscription">
                                <div class="your-dates__upgrade-subscription">
                                    <h3>Upgrade your subscription</h3>
                                    <p>If you want to see when are your <span class="color-gold">BOOST</span> days
                                        please upgrade your subscription.</p>
                                    <a href="###LINKTOBUY###" class="button button--small button--primary">Upgrade</a>
                                </div>
                            </div>
                            -->

                            <!--
                            <button class="your-dates__date your-dates__date--load-other-categories">
                                <h3><strong>Load more dates for March </strong>from other subcategories</h3>
                                <div class="load-other-categories__button">
                                    <div class="button button--gray button--small">Load more dates</div>
                                </div>
                            </button>
                            -->

                        </div>
                        <div v-if="datesFromDifferentSubcategories.length>0" class="your-dates__container">
                            <div class="your-dates__title" v-translate>Personal energy supported days from different subcategories
                            </div>
                            <div class="your-dates__description" v-translate>
                                These are also your energy supported days from compatible subcategories of your selected category.
                            </div>
                            <energy-supported-date :activity="activity" v-for="(day,index) in datesFromDifferentSubcategories" :day="day"
                                                   :multiple="true" v-model="selected_date" :key="day.date+index"/>
                        </div>
                    </div>
                    <div class="your-dates__container">
                        <div class="your-dates__title" v-translate>Other personal days</div>
                        <div class="your-dates__description" v-translate>
                            These are not your energy supported days. Always try to do activities on energy supported
                            days. If you choose days below make sure to read how you should act on those days.
                        </div>
                        <tong-shu-date v-for="(day, index) in tongShuDates" :day="day" v-model="selected_date"
                                       :activity="activity" :key="day.date+index"/>
                        <!--
                        <div class="your-dates__date your-dates__date--upgrade-subscription">
                            <div class="your-dates__upgrade-subscription">
                                <h3>Extend your subscription</h3>
                                <p>Your subscription expires on 31. May 2019. To see more days please extend your subscriptions.</p>
                                <a href="###LINKTOBUY###" class="button button--small button--primary">Extend</a>
                            </div>
                        </div>
                        -->
                    </div>
                    <div class="your-dates__no-dates-container">
                        <h3 v-translate>Above dates are not suitable for you?</h3>
                        <div class="your-dates__choose-custom-day">
                            <strong v-translate>Choose specific day</strong>
                            <div class="choose-date-range">
                                <input-field :field="$v.selected_date" type="datepicker-on-top" label="Choose specific date"></input-field>
                                <!--<datepicker-on-top v-model="selected_date"/>-->
                            </div>

                            <!-- KO IZBERES DATUM SE POJAVI TONG SHU DATUMA -->
                            <div v-if="selected_date!==null && day!==null" class="your-dates__selected-day-description">

                                <div class="message message--danger" v-if="day.dire" :key="'dire-day-message'" v-translate>
                                    This is a very negative energy supported day. Try to focus on ongoing activities and avoid starting important activities.
                                </div>


                                <tune-your-day-bars v-if="day!==null" :day="day"></tune-your-day-bars>
                                <tune-your-day-description v-if="day!==null" :day="day" ></tune-your-day-description>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="zq-popup__bottom">
                <button @click="chooseDate()" v-if="selected_date!==null && selectedDateValid" class="button button--primary" :key="'choose-date'" v-translate>Choose date</button>
                <button @click="closePopup()" class="button button--gray closePopup" data-close-popup-id="choose-date-popup" :key="'close'" v-translate>Close</button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapState} from 'vuex';
    import moment from "moment";
    import axios from "axios";
    import EnergySupportedDate from "./EnergySupportedDate";
    import TongShuDate from "./TongShuDate";
    import TuneYourDayBars from "../../components/dashboard/TuneYourDayBars";
    import TuneYourDayDescription from "../../components/dashboard/TuneYourDayDescription";
    import InputField from "./InputField";

    export default {
        name: 'ChooseDate',
        components: {
            TuneYourDayDescription, TuneYourDayBars, TongShuDate, EnergySupportedDate, InputField},
        data() {
            return {
                selected_month: moment().format('YYYY-MM-DD'),
                selected_date: null,
                calendar: [],
                picked_date: null,
                day: null,
            }
        },
        methods: {
            ...mapActions([
                'closePopup'
            ]),
            monthForward: function () {
                this.selected_month = moment(this.selected_month).add(1, 'month').format('YYYY-MM-DD');
            },
            monthBack: function () {
                let new_month = moment(this.selected_month).subtract(1, 'month').format('YYYY-MM-DD');
                if (moment(new_month) >= moment().startOf('month')) {
                    this.selected_month = new_month
                }
            }, loadCalendar: async function () {
                this.calendar = (await axios.get('api/navigator/calendar/' + this.start_end + '/')).data

            },
            loadDay: async function () {
                this.day = (await axios.get('/api/navigator/day-detail/' + this.selected_date + '/')).data
            },
            chooseDate: function () {
                this.$set(this.activity, 'date', this.selected_date)
                this.closePopup()
            }
        },
        computed: {
            selectedDateValid: function() {
                return moment(this.selected_date) >= moment().startOf('day')
            },
            ...mapState({
                'activity': 'popupPayload',
                'categories': 'categories',
            }),
            canGoBack: function () {
                return (moment(this.selected_month).startOf('month') > moment().startOf('month'))
            },
            start_end: function () {
                return this.start_date + '/' + this.end_date
            },
            start_date: function () {
                return moment(this.selected_month).startOf('month').format('YYYY-MM-DD')
            },
            end_date: function () {
                return moment(this.selected_month).endOf('month').format('YYYY-MM-DD')
            },
            transformedCalendar: function () {
                let supported_days = Object.keys(this.calendar).sort()
                let result = []
                for (let i = 0; i < supported_days.length; i++) {
                    for (let j = 0; j < this.calendar[supported_days[i]].supported.length; j++) {
                        result.push({
                            ...this.calendar[supported_days[i]].supported[j],
                            date: supported_days[i],
                            supported: this.calendar[supported_days[i]].supported.filter(x => x.category == this.calendar[supported_days[i]].supported[j].category)
                        })
                    }
                }
                return result
            },
            datesForSelectedSubcategory: function () {
                return this.transformedCalendar.filter(day => day.subcategory == this.activity.subcategory && moment(day.date) >= moment().startOf('day'))
            },
            dateKeysForSelectedSubcategory: function () {
                return this.datesForSelectedSubcategory.map(day => day.date)
            },
            datesFromDifferentSubcategories: function () {
                let dates = this.transformedCalendar.filter(day => day.subcategory != this.activity.subcategory && day.category == this.activity.category && !this.dateKeysForSelectedSubcategory.includes(day.date) && moment(day.date) >= moment().startOf('day'))
                let result = []
                let seen = []
                for (let i = 0; i < dates.length; i++) {
                    if (!seen.includes(dates[i].date)) {
                        seen.push(dates[i].date)
                        result.push(dates[i])
                    }
                }
                return result
            },
            dateKeysFromDifferentSubcategories: function () {
                return this.datesFromDifferentSubcategories.map(day => day.date)
            },
            tongShuDates: function () {
                let days = Object.keys(this.calendar).sort()
                let result = []
                for (let i = 0; i < days.length; i++) {
                    if (this.calendar[days[i]].tong_shu.activities.filter(x => x.category == this.activity.category).length > 0) {
                        result.push({
                            ...this.calendar[days[i]].tong_shu,
                            date: days[i],
                        })
                    }
                }
                return result.filter(day => !day.dire && moment(day.date) >= moment().startOf('day') && !this.dateKeysForSelectedSubcategory.includes(day.date) && !this.dateKeysFromDifferentSubcategories.includes(day.date))
            },
            subcategoryName: function () {
                for (let i = 0; i < this.categories.length; i++) {
                    for (let j = 0; j < this.categories[i].subcategories.length; j++) {
                        if (this.categories[i].subcategories[j].id == this.activity.subcategory) {
                            return this.categories[i].subcategories[j].name
                        }
                    }
                }
                return ''
            },
            categoryName: function () {
                for (let i = 0; i < this.categories.length; i++) {
                    if (this.categories[i].id == this.activity.category) {
                        return this.categories[i].name
                    }
                }
                return ''
            },
            selectedMonth: function() {
                return moment(this.selected_month).format('MMMM YYYY')
            }
        },
        watch: {
            selected_month: async function () {
                this.loadCalendar()
            },
            selected_date: function (newData) {
                if (newData !== null) {
                    this.selected_date = moment(newData).format('YYYY-MM-DD')
                    this.loadDay()
                }
            }
        },
        validations: {
            selected_date: {}
        },
        beforeMount: function () {
            this.loadCalendar()
        }
    }
</script>